
<script>
  import { __ } from '~/data-utils';
  import Events from '~/events';
  import { lang, selected3rdParty } from 'apps/imd/stores';

  let url_lang;
  let url;
  let color;
  let overflowControls;

  let iframe;
  let iframeOrigin;
  let navDepth = 0;
  let isLoadingSuccess;

  $: if (url) {
    iframeOrigin = new URL(url).origin;
    isLoadingSuccess = true;
  }

  $: {
    ({
      url,
      color,
      overflowControls = false
    } = $selected3rdParty);

    const [href, ...query] = url.split(/[?&]/);
    url_lang = `${href}?${query.concat(`lang=${$lang}`).join('&')}`;
  }

  function contentLoaded () {
    isLoadingSuccess = true;
    Events.dispatchEvent('thirdparty:content:success');
  }

  function loadingFailed (event) {
    console.error('loadingFailed', event);
    isLoadingSuccess = false;
    Events.dispatchEvent('thirdparty:content:failed');
  }

  function receiveMessage(event) {

    // Security check
    if (event.origin !== iframeOrigin || event.source !== iframe.contentWindow)
      return;

    if (event.data === 'send_next:nav_back') {
      navDepth += 1;
    }
    // ASSUMING that all events are user generated so we can reset session timer
    Events.dispatchEvent('user:activity');
  }

  export function handleNavBack() {
    if (navDepth) {
      navDepth -= 1;
      iframe.contentWindow.postMessage('nav_back', iframeOrigin);
      return true;
    }
    return false;
  }

</script>

<svelte:window on:message={receiveMessage} />

{#if isLoadingSuccess}
  <iframe class:overflow-controls={overflowControls}
    bind:this={iframe}
    src="{url_lang}"
    sandbox="allow-same-origin allow-scripts"
    on:load={contentLoaded}
    on:error={loadingFailed}
    title="3rd Party Content"></iframe>
{:else}
  <section class="no-content">
    <h1>{__('thirdpartyiframe.notloaded')}</h1>
  </section>
{/if}

<style media="screen">

  iframe {
    width: 100%;
    height: calc(100% - 136px);
    border: none;
  }

  .overflow-controls {
    position: absolute;
    height: 100%;
    top: 0;
  }

  .no-content {
    display: flex;
    height: calc(100% - 136px);
    justify-content: center;
    align-items: center;
  }
</style>
